import { Select, Spin, Typography } from 'antd';

import { filterItems } from '@app/components/VisitsHistory/data/constants';
import {
  useVisitsHistory,
  useVisitsHistoryEffects,
} from '@app/components/VisitsHistory/hooks';
import type { VisitsHistoryType } from '@app/components/VisitsHistory/types';
import { VisitsTable } from '@app/components/VisitsHistory/ui';

import '@app/components/VisitsHistory/styles/VisitsHistory.desktop.scss';
import '@app/components/VisitsHistory/styles/VisitsHistory.mobile.scss';

const PF = 'visit-history';
const { Title, Text } = Typography;

export const VisitsHistory: VisitsHistoryType = (props) => {
  const {
    onSelect,
    visitsCount,
    onOpenRecord,
    onOpenRecordNewTab,
    visitTableData,
    isLoadingPage,
    getClientRecordsHandler,
  } = useVisitsHistory(props);

  useVisitsHistoryEffects({ getClientRecordsHandler });

  return (
    <div className={`${PF}_container`}>
      <Title
        className={`${PF}_title`}
        level={4}
        data-testid="visits-history-title"
      >
        История визитов
      </Title>
      <div className={`${PF}_content`}>
        <div className={`${PF}_filter`}>
          <Select
            className={`${PF}_filter_select`}
            data-testid="visit-dropdown"
            defaultValue={filterItems[0].value}
            onChange={onSelect}
            options={filterItems.map(({ testId, title, ...item }) => ({
              label: <span data-testid={testId}>{title}</span>,
              ...item,
            }))}
            disabled={isLoadingPage}
            loading={isLoadingPage}
          />
          <Text className={`${PF}_filter_title`} data-testid="visit-count">
            Количество визитов: {visitsCount}
          </Text>
        </div>

        {isLoadingPage ? (
          <div className={`${PF}_loading`}>
            <Spin size="large" spinning />
          </div>
        ) : (
          <VisitsTable
            data={visitTableData}
            onOpenRecord={onOpenRecord}
            onOpenRecordNewTab={onOpenRecordNewTab}
          />
        )}
      </div>
    </div>
  );
};
